import React from "react";
import Increment from "./buttons/Incrememt";
import Decrement from "./buttons/Decrement";
import TextCell from "./gridCells/TextCell";
import { ActionOnKey } from "../interfaces/ActionOnKey";
import { RuleItemConfig } from "../interfaces/RuleItemConfig";

interface Props {
  itemKey: string;
  rank: number;
  config: RuleItemConfig;
  onClick: (action: ActionOnKey) => void;
}

export default ({ itemKey, rank, config, onClick }: Props) => {
  const canInc = rank < config.max;
  const canDec = rank > config.min;
  if (!canInc && !canDec) {
    return <TextCell dataTest="class-rank-key" text={rank} />;
  }
  const actionInc: ActionOnKey = { key: itemKey, action: "inc" };
  const actionDec: ActionOnKey = { key: itemKey, action: "dec" };
  return (
    <div className="grid-rank">
      <Decrement
        dataTest={`dec-${itemKey}`}
        onClick={() => onClick(actionDec)}
      />
      <TextCell dataTest={`rank-${itemKey}`} text={rank} />
      <Increment
        dataTest={`inc-${itemKey}`}
        onClick={() => onClick(actionInc)}
      />
    </div>
  );
};
